export default {
  methods: {
    hasConfig: function hasConfig(configName) {
      if (!this.designer || !this.designer.selectedWidget) {
        return false;
      }
      return this.designer.hasConfig(this.selectedWidget, configName);
    },
    emitDefaultValueChange: function emitDefaultValueChange() {
      if (!!this.designer) {
        if (!!this.designer.formWidget) {
          var fieldWidget = this.designer.formWidget.getWidgetRef(this.designer.selectedWidget.options.name);
          if (!!fieldWidget && !!fieldWidget.refreshDefaultValue) {
            fieldWidget.refreshDefaultValue();
          }
        }
      }
    },
    inputNumberHandler: function inputNumberHandler(_ref) {
      var target = _ref.target;
      target.value = target.value.replace(/[^0-9]/gi, '');
    },
    onRemoteChange: function onRemoteChange(val) {
      if (!!val) {
        this.optionModel.filterable = true;
        this.optionModel.allowCreate = false;
      }
    },
    onMultipleSelected: function onMultipleSelected(val) {
      if (val) {
        //debugger

        // 清空已选项，否则console会报错！！
        var foundRef = this.designer.formWidget.getWidgetRef(this.optionModel.name);
        if (!!foundRef && !!foundRef.clearSelectedOptions) {
          foundRef.clearSelectedOptions();
        }
        this.optionModel.defaultValue = []; //清空原默认值!!
      } else {
        if (!!this.optionModel.defaultValue && this.optionModel.defaultValue.length > 0) {
          this.optionModel.defaultValue = this.optionModel.defaultValue[0];
        } else {
          this.optionModel.defaultValue = '';
        }
      }
    }
  }
};